export const APP_NAME = 'skill_page_perseus';
